import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../lib/api';

export default function Reports() {
  const { idToken } = useAuth();
  const [me, setMe] = useState<any>(null);
  const [cheapest, setCheapest] = useState<any>(null);
  const [eia, setEia] = useState<any>(null);

  useEffect(() => {
    api('/api/me', { token: idToken! }).then(setMe);
    api('/api/reports/eia', { token: idToken! }).then(setEia).catch(() => {});
  }, []);

  useEffect(() => {
    if (!me) return;
    api(`/api/reports/cheapest?zip=${me.zip}&miles=25`, { token: idToken! }).then(setCheapest).catch(() => {});
  }, [me]);

  return (
    <div className="container">
      <div className="grid two">
        <div className="card">
          <h3>Cheapest stations within 25 mi</h3>
          <table>
            <thead><tr><th>Station</th><th>Brand</th><th>Dist</th><th style={{ textAlign: 'right' }}>Price</th><th style={{ textAlign: 'right' }}>Tax/gal</th></tr></thead>
            <tbody>
              {(cheapest?.rows ?? []).map((r: any, i: number) => (
                <tr key={i}>
                  <td>{r.station}</td>
                  <td className="muted">{r.brand}</td>
                  <td>{r.distanceMiles} mi</td>
                  <td style={{ textAlign: 'right' }}>${r.price?.toFixed(4)}</td>
                  <td style={{ textAlign: 'right' }}>{r.totalTax ? `$${r.totalTax.toFixed(4)}` : '—'}</td>
                </tr>
              ))}
              {cheapest && cheapest.rows.length === 0 && <tr><td colSpan={5} className="muted">No prices available from enabled sources. OSM has locations but no live prices; enable HERE in Admin → Sources for station-level pricing.</td></tr>}
            </tbody>
          </table>
        </div>

        <div className="card">
          <h3>EIA weekly retail — US regular</h3>
          <table>
            <thead><tr><th>Region</th><th>Period</th><th style={{ textAlign: 'right' }}>$/gal</th></tr></thead>
            <tbody>
              {(eia?.rows ?? []).map((r: any, i: number) => (
                <tr key={i}><td>{r.region}</td><td className="muted">{r.observedAt}</td><td style={{ textAlign: 'right' }}>${Number(r.price).toFixed(3)}</td></tr>
              ))}
              {eia && eia.rows.length === 0 && <tr><td colSpan={3} className="muted">EIA source disabled or rate-limited.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
